import React from "react";

import StandardLayout from "components/Library/Layout/containers/StandardLayout";
import BrandedDeepDiveHeader from "stream/components/BrandedDeepDiveHeader";
import LatestStories from "components/Library/LatestStories";
import StreamAd from "stream/containers/StreamAd";

export default function BrandedDeepDive() {
  return (
    <StandardLayout
      main={
        <>
          <BrandedDeepDiveHeader />
          <div>
            {[...Array(20).keys()].map(num => (
              <StreamAd
                key={num}
                node={{
                  adUnit: "section-sponsored",
                  targeting: {
                    "stream-name": "test-example",
                    "stream-pos": `pos${num + 1}`,
                  },
                }}
              />
            ))}
          </div>
        </>
      }
      complementary={<LatestStories />}
      mainAriaLabel="Branded Deep Dive Stories"
    />
  );
}
